// components/admin/employees/GridEmployees.jsx
"use client";

// import { MdOutlineFaceUnlock } from "react-icons/md"
import ClientProfileCard from "./AgentProfileCard";
// import { profiles } from "../StaticData/ClientProfileData"

export default function ProfileGrid({ agents }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3">
      {agents.map((agent, index) => (
        <ClientProfileCard key={index} agent={agent} />
      ))}
    </div>
  );
}
